/* eslint-disable no-restricted-globals */
import { logInfo } from "src/utils/logging";
import { CoreReduxState } from "src/utils/redux/store";
import { getPage, getPageSet, getPageSetFromPage } from ".";
import { Direction, PageSet } from "../types";
import { emitPageSetEvents } from "./bus";

export function resolveParamPageSet(state: CoreReduxState) {
  const persistedPageSet = getPageSet(state.linearBuyflow.pageSetName);

  // Urls set on query params override current
  let discoveredPageSet = pullPageSetFromUrl(location, state);

  if (!discoveredPageSet && !persistedPageSet) {
    // Check out current url and see if it matches a page set.
    discoveredPageSet = getPageSetFromPage(location.pathname, state);
  }

  if (discoveredPageSet && discoveredPageSet !== persistedPageSet) {
    // Strip URL param and replace state
    history.replaceState(history.state, null, removePageSetParameter(location));

    logInfo(`Setting active page set to ${discoveredPageSet.id}`);
    emitPageSetEvents("set:page-set", {
      activePageSet: discoveredPageSet,
      direction: Direction.FORWARD,

      // These aren't available yet so make the listener figure it out.
      history: null,
      store: null,
    });
    return discoveredPageSet;
  }
  return undefined;
}

// When a user lands on a pool page, we need two pieces of information to
// direct them to the correct page.
// 1. Page Set ID
//    The Page Set ID is stored either in the URL's querystring ?psid=<pageSetId>
//    or in redux in the 'linearBuyflow' slice.
// 2. Page Pathname
//    For example: https://www.noom.com/p/landing -> `/p/landing`
function pullPageSetFromUrl(
  location: Location,
  state: CoreReduxState
): PageSet {
  const psid = new URLSearchParams(location.search).get("psid");
  const activePageSet = getPageSet(psid);
  if (!activePageSet) {
    return null;
  }

  // 3. Finally set the active page set and active page in redux.
  const isPartOfPageSet = getPage(
    activePageSet.pages,
    location.pathname,
    state
  );
  if (isPartOfPageSet) {
    return activePageSet;
  }

  return null;
}

function removePageSetParameter(location: Location) {
  const url = new URL(location.href);
  url.searchParams.delete("psid");

  return url.toString();
}
